// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsOxides_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="8" class="svg-bg"/>
  <path d="M8.03906 11.6084C7.03646 11.6084 6.2194 11.2829 5.58789 10.6318C4.95638 9.97754 4.64062 9.1263 4.64062 8.07812C4.64062 6.97135 4.96126 6.07617 5.60254 5.39258C6.24382 4.70898 7.09342 4.36719 8.15137 4.36719C9.15072 4.36719 9.95801 4.69434 10.5732 5.34863C11.1917 6.00293 11.501 6.86556 11.501 7.93652C11.501 9.03678 11.1803 9.92383 10.5391 10.5977C9.90104 11.2715 9.06771 11.6084 8.03906 11.6084ZM8.10742 5.72461C7.55404 5.72461 7.11458 5.93294 6.78906 6.34961C6.46354 6.76302 6.30078 7.31152 6.30078 7.99512C6.30078 8.68848 6.46354 9.23698 6.78906 9.64062C7.11458 10.0443 7.54102 10.2461 8.06836 10.2461C8.61198 10.2461 9.04329 10.0508 9.3623 9.66016C9.68131 9.26628 9.84082 8.72103 9.84082 8.02441C9.84082 7.2985 9.6862 6.73372 9.37695 6.33008C9.06771 5.92643 8.64453 5.72461 8.10742 5.72461Z" class="svg-fg"/>
</svg>
`;
/**
 * IconRmsOxides is a generated icon component.
 */
let IconRmsOxides = IconRmsOxides_1 = class IconRmsOxides extends IconBaseElement {
    render() {
        return html `${IconRmsOxides_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsOxides.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconRmsOxides = IconRmsOxides_1 = __decorate([
    customElement('zui-icon-rms-oxides')
], IconRmsOxides);
export { IconRmsOxides };
